import { NgbDate, NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';

/**
 * This adapter is used to convert values when using ngbDatepicker.
 */
@Injectable({ providedIn: 'root' })
export class DatePickerStringAdapter extends NgbDateAdapter<string> {

  /**
   * Converts date from string to NgbDateStruct.
   * For example, it would convert '2022-01-01' to new NgbDate(2022, 1, 1).
   * @param value date as string
   */
  fromModel(value: string): NgbDateStruct {
    if (!value) {
      return;
    }
    const split = value.split('-');
    const year = parseInt(split[0], 10);
    const month = parseInt(split[1], 10);
    const day = parseInt(split[2], 10);
    return new NgbDate(year, month, day);
  }

  /**
   * Converts date from NgbDateStruct to string.
   * For example, it would convert new NgbDate(2022, 1, 1) to '2022-01-01'.
   * @param date date as NgbDateStruct
   */
  toModel(date: NgbDateStruct): string {
    if (!date) {
      return;
    }
    const year = date.year;
    const month = this.pad(date.month);
    const day = this.pad(date.day);
    return `${year}-${month}-${day}`;
  }

  private pad(i: number): string {
    return i < 10 ? `0${i}` : `${i}`;
  }
}
